// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LAScBOqn{line-height:1.2}.LAScBOqn ul{list-style-type:none;padding:0;margin:0}.LAScBOqn ul li li{margin-left:1em}._5MSHn0uv,.DFXUTZY9{text-transform:uppercase}.Ds_VYtud,.ItdMP4FU{opacity:.8}.Ds_VYtud::before,.Ds_VYtud::after,.ItdMP4FU::before,.ItdMP4FU::after{content:"-"}`, "",{"version":3,"sources":["webpack://./src/utilities/components/nested-list/nested-list.module.scss"],"names":[],"mappings":"AAAA,UACE,eAAA,CAEA,aACE,oBAAA,CACA,SAAA,CACA,QAAA,CAGE,mBACE,eAAA,CAMR,qBACE,wBAAA,CAGF,oBACE,UAAA,CAEA,sEACE,WAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nestedListWrapper": `LAScBOqn`,
	"undefined": `_5MSHn0uv`,
	"null": `DFXUTZY9`,
	"emptyArray": `Ds_VYtud`,
	"emptyString": `ItdMP4FU`
};
export default ___CSS_LOADER_EXPORT___;
